// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".head[data-v-1411a25c]{display:flex;justify-content:space-between;margin-bottom:20px}.exam-name[data-v-1411a25c]{font-size:22px;font-weight:700}.head-left[data-v-1411a25c]{border-left:5px solid #2f527b;padding-left:10px}.head-right[data-v-1411a25c]{padding:10px;background-color:#ed5900;color:#fff}", ""]);
// Exports
module.exports = exports;
